import React from 'react';
import { History } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import Booking from './components/Booking';
import NotFound from './components/NotFound';
import './App.css';

import { anaTheme } from './themes/ana';
import { universalMaaS } from './themes/universalMaaS';
import { ThemeProvider } from '@material-ui/core';
// import Helmet from 'react-helmet';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Path from './utils/path';
import BookingTaxi from './components/ad/OtherServices/AirportTransferTaxi/TemporaryReservation';
import SuccessBookingTaxi from './components/ad/OtherServices/AirportTransferTaxi/TemporaryReservation/Success';
import Unreceived from './components/ad/OtherServices/AirportTransferTaxi/TemporaryReservation/Unreceived';
import LinkToTabicube from './components/LinkToTabicube';

interface AppProps {
  history: History;
}

const App: React.FC<AppProps> = ({ history }: AppProps) => {
  /** 適用するTheme。 */
  // Publicモードの場合はUniversal MaaS、それ以外（Closedモード）の場合はClosedモード用のThemeを適用する。
  const theme = Path.isPublic(window.location.pathname) ? universalMaaS : anaTheme;
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet>
          <link rel="preconnect" href="https://fonts.gstatic.com"/>
          <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;700&display=swap" rel="stylesheet"/>
        </Helmet>
      </HelmetProvider>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          <Switch>
            {/* 空港アクセスナビ・そらたびのパス（旅CUBEにリダイレクトする）。 */}
            <Route path="/" exact component={LinkToTabicube} />
            <Route path="/search" exact component={LinkToTabicube} />
            <Route path="/result" exact component={LinkToTabicube} />
            <Route path="/summary" exact component={LinkToTabicube} />
            <Route path="/public" exact component={LinkToTabicube} />
            <Route path="/public/summary" exact component={LinkToTabicube} />
            <Route path="/public/result" exact component={LinkToTabicube} />
            {/* タクシー予約に関するパス。 */}
            <Route path="/booking" exact component={Booking} />
            <Route path="/booking-taxi" exact component={BookingTaxi} />
            <Route path="/booking-taxi/success" exact component={SuccessBookingTaxi} />
            <Route path="/booking-taxi/unreceived" exact component={Unreceived}/>
            {/* 404ページ。 */}
            <Route path="/404" exact component={NotFound} />
            <Route component={NotFound} />
          </Switch>
        </ThemeProvider>
      </ConnectedRouter>
    </div>
  );
}

export default App;
